module.exports = __webpack_public_path__ + "static/media/doorprize.03a7d5c1.png";